<section class="container-wrapper" [ngClass]="'container-wrapper-theme-' + className()">
  <mat-label class="label" [class.required]="!hideRequiredMarker() && datePickerControl().hasValidator(Validators.required)"
    >{{ label() || '' | translate }}
    @if (infoTooltip()) {
      <mat-icon class="help-icon" svgIcon="icon_info_24" [appTooltip]="infoTooltip() | translate" [position]="TooltipPosition.BELOW" />
    }
  </mat-label>
  <mat-form-field class="container" appearance="outline" [class.readonly]="readonly()">
    <input
      matInput
      [disabled]="readonly()"
      [placeholder]="placeholder() || '' | translate"
      [formControl]="datePickerControl()"
      [matDatepicker]="customDatePicker"
      [min]="minDate()"
      [max]="maxDate()"
      (dateChange)="pickerChangesEvent.emit($event)"
    />
    <mat-datepicker-toggle matSuffix [for]="customDatePicker" />
    <mat-datepicker #customDatePicker />

    @let firstError = getFirstError();
    @if (firstError) {
      <mat-error class="error-active">
        {{ firstError.message | translate }}
      </mat-error>
    } @else if(hintMessage()) {
      <mat-hint class="field-hint">
        {{ hintMessage() | translate }}
      </mat-hint>
    }
  </mat-form-field>
</section>
